@if (data && informations) {
  <div>
    <app-form
      [informations]="informations"
      [data]="data"
      [helptexts]="helptexts[0]"
      (dataSubmitted)="onData($event)"
    ></app-form>
  </div>
}

<button mat-raised-button color="primary" (click)="addUser()" i18n="add company user@@add_company_user">
  Add Company User
</button>
@if (currentUser && users && userinformations && helptexts) {
  @for (user of users; track user) {
    <div>
      <app-form
        [informations]="userinformations"
        [data]="user"
        [showDelete]="user.id !== currentUser.id"
        (deleted)="deleteUser($event)"
        (dataSubmitted)="onUserData($event)"
      ></app-form>
    </div>
  }
}
